export default "__VITE_PUBLIC_ASSET__a92a6893__"